import { useCallback, useReducer } from "react";

const useCustomReducer = (reducer, initialState) => {
  const customReducer = useCallback(
    (state, action) => {
      if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        const { type, ...payload } = action;

        console.groupCollapsed(type);
        console.log("%c state", "color: green; font-weight: bold;", state);
        console.log("%c payload", "color: green; font-weight: bold;", payload || "");
        console.groupEnd();
      }

      return reducer(state, action);
    },
    [reducer]
  );

  const [state, dispatch] = useReducer(customReducer, initialState);

  return [state, dispatch];
};

export default useCustomReducer;
